import React from 'react';
import './Loading.css';

const Loading = ({ error, message = 'Yükleniyor...', logoSrc }) => {
  return (
    <div className="loading-container">
      <div className="loading-content">
        {logoSrc && (
          <img
            src={logoSrc}
            alt="Logo"
            className="loading-logo"
            draggable="false"
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
        )}
        {!error && <div className="loading-spinner"></div>}
        <div className={`loading-text ${error ? 'error' : ''}`}>
          {message}
        </div>
      </div>
    </div>
  );
};

export default Loading;
